import React from "react";
import "./section8Element.css";

import {
  Twitter
} from "@material-ui/icons";
const Section8Element = ({section8Imgs, section8ImgName, section8ImgFounder, address}) => {
  return (
    <div className="section8Element-main-wrapper">
      <div className="section8Element-List">
        <img src={section8Imgs} alt="section8Imgs" className="section8-img"/>
        <h6>{section8ImgName}</h6>
        <p>{section8ImgFounder}</p>
        <a href={address} target="_blank">
        <Twitter className="twitterIcon" style={{ fontSize: "25px", color: "#FFFFFF", justifyContent: "center" }} />
        </a>
      </div>
    </div>
  );
};

export default Section8Element;
